import React, { useState, useContext, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import logo from "./maximusLogo.png";
import {
  SocialMedia,
  ProtestsHistory,
  SLA,
  StaffingLevels,
} from "./Dashboards";
import GRStrategies from "./Dashboards/GRStrategies.tsx";
import PRStrategies from "./Dashboards/PRStrategies.tsx";
import TopStories from "./Dashboards/TopStories.tsx";
import { MdOutlineFolderCopy } from "react-icons/md";
import { PiGraduationCap } from "react-icons/pi";
import { FaRegUser } from "react-icons/fa";
import "./Layout.css";

export default function Layout() {
  const [project, setProject] = useState("cco");

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Stack direction="row" spacing={2}>
      <div className="sidebar">
        <img src={logo} alt="Maximus logo" className="logo" />
        <MenuList>
          <MenuItem
            onClick={() => setProject("cco")}
            className={project === "cco" ? "selected" : ""}
          >
            <MdOutlineFolderCopy /> CCO
          </MenuItem>
          <MenuItem disabled>
            <PiGraduationCap /> AidVantage
          </MenuItem>
        </MenuList>
      </div>
      <div className="main-page">
        <MenuList className="horizontal-menu">
          <MenuItem
            onClick={() => navigate("/protests-history")}
            className={
              location.pathname === "/protests-history" ? "selected" : ""
            }
          >
            Protests History
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/sla")}
            className={location.pathname === "/sla" ? "selected" : ""}
          >
            SLAs
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/staffing-levels")}
            className={
              location.pathname === "/staffing-levels" ? "selected" : ""
            }
          >
            Staffing Levels
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/top-stories")}
            className={location.pathname === "/top-stories" ? "selected" : ""}
          >
            Top Stories
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/social-media")}
            className={location.pathname === "/social-media" ? "selected" : ""}
          >
            Social Media Listening
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/gr-strategies")}
            className={location.pathname === "/gr-strategies" ? "selected" : ""}
          >
            GR Strategies
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/pr-strategies")}
            className={location.pathname === "/pr-strategies" ? "selected" : ""}
          >
            PR Strategies
          </MenuItem>
        </MenuList>
        <div className="main-content">
          <Routes>
            <Route path="protests-history" element={<ProtestsHistory />} />
            <Route path="sla" element={<SLA />} />
            <Route path="staffing-levels" element={<StaffingLevels />} />
            <Route path="top-stories" element={<TopStories />} />
            <Route path="social-media" element={<SocialMedia />} />
            <Route path="gr-strategies" element={<GRStrategies />} />
            <Route path="pr-strategies" element={<PRStrategies />} />
            <Route
              path="/"
              element={<Navigate to="protests-history" replace />}
            />
          </Routes>
        </div>
      </div>
    </Stack>
  );
}
